import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// routes
import { PATH_PAGE } from '../routes/paths';
// components
import LoadingScreen from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();

  if (isAuthenticated) {
    if (user.role !== 'admin') {
      return <Navigate to={PATH_PAGE.page404} />;
    }
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <> {children} </>;
}
